import { render, staticRenderFns } from "./reduce.vue?vue&type=template&id=4df21c50&scoped=true"
import script from "./reduce.vue?vue&type=script&lang=js"
export * from "./reduce.vue?vue&type=script&lang=js"
import style0 from "./reduce.vue?vue&type=style&index=0&id=4df21c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df21c50",
  null
  
)

export default component.exports